// HOC shared by both register and account flows
import { withPaymentQuery } from 'components/account/Billing/Payment'

// presentational component specific to registration flow
import UI from './UI'

export default withPaymentQuery(UI)
